import React from 'react';

export default function NavBar() {
  return (
    <nav className="navbar navbar-light bg-light ps-4">
    </nav>
  )
}
